import { useEffect, useState } from "react";
import ITicket from "../../../models/helpdesk/hr/ITicket";
import { useTranslation } from "react-i18next";
import Status from "../../../enums/Status";
import { Alert, Col, Container, ListGroup, Row, Spinner } from "react-bootstrap";
import Ticket from "./Ticket";
import { v4 as uuid } from "uuid";
import hrHelpdeskService from "../../../services/hrHelpdeskService";

const TicketsHeader = () => {
    const { t } = useTranslation();

    return (
        <ListGroup.Item key={uuid()}>
            <Container fluid className="d-none d-lg-block">
                <Row>
                    <Col xs={3} className="fw-bold">{t("hr.my.table.headers.title")}</Col>
                    <Col xs={2} className="fw-bold">{t("hr.my.table.headers.created")}</Col>
                    <Col xs={2} className="fw-bold">{t("hr.my.table.headers.status")}</Col>
                    <Col xs={3} className="fw-bold">{t("hr.my.table.headers.category")}</Col>
                    <Col xs={2} className="fw-bold">{t("hr.my.table.headers.required")}</Col>
                </Row>
            </Container>
        </ListGroup.Item>
    );
}

export default function Tickets() {
    const { t } = useTranslation();

    const [tickets, setTickets] = useState<ITicket[]>([]);
    const [status, setStatus] = useState<Status>(Status.LOADING);

    useEffect(() => {
        getTickets(setTickets)
            .then(() => setStatus(Status.LOAD_SUCCESS))
            .catch(() => setStatus(Status.LOAD_ERROR));
    }, []);

    return (
        <Container fluid>
            <Row>
                <Col>
                    <h2>{t("hr.my.title")}</h2>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    {
                        (
                            status === Status.LOADING &&
                            <div className="text-center">
                                <Spinner />
                                <span className="d-block sfw-bold">{t("hr.my.loading")}</span>
                            </div>
                        ) ||
                        (
                            status === Status.LOAD_ERROR &&
                            <Alert variant="danger">
                                {t("hr.my.errors.general")}
                            </Alert>
                        ) ||
                        (
                            tickets.length === 0 &&
                            <Alert variant="info">
                                {t("hr.my.errors.noTickets")}
                            </Alert>
                        ) ||
                        <ListGroup variant="flush">
                            <TicketsHeader />
                            {
                                tickets.map(ticket => <Ticket key={uuid()} ticket={ticket} />)
                            }
                        </ListGroup>
                    }
                </Col>
            </Row>
        </Container>
    );
}

async function getTickets(setTickets: (tickets: ITicket[]) => void) {
    const tickets = await hrHelpdeskService.getTickets();
    setTickets(tickets);
}